import isNil from 'lodash/isNil'
import { createSelector } from 'reselect'

const getState = state => state.ui

export const getUi = createSelector([getState], data => (isNil(data) ? data : data.toJS()))
